module.exports = __webpack_public_path__ + "static/media/4-3.7481fdc6.png";